export default class BGCheckAccount {
  id: number = null;
  organizationId: number = null;
  enabled: boolean = false;
  partner: string = null;
  scope: string = null;
}
